import api from "../../../services/api";
import {
  ICreateSubAccountPayload,
  ISubAccount,
  IUpdateSubAccountPayload,
  IOwnerPropertyOption,
} from "../types";
import {
  normalizeOwnerPropertiesList,
  normalizeSubAccount,
  normalizeSubAccountsList,
} from "../utils/normalizeSubAccount";
import { filterParentProperties } from "../../../utils/propertyDisplay";

const SUB_ACCOUNTS_ENDPOINT = "/api/client/owner/sub-accounts";
const PROPERTIES_ENDPOINT = "/api/client/owner/properties";

export async function fetchOwnerSubAccounts(): Promise<ISubAccount[]> {
  const response = await api.get(SUB_ACCOUNTS_ENDPOINT);
  return normalizeSubAccountsList(response.data);
}

export async function fetchOwnerPropertiesForAccess(): Promise<
  IOwnerPropertyOption[]
> {
  const response = await api.get(PROPERTIES_ENDPOINT);
  return filterParentProperties(normalizeOwnerPropertiesList(response.data));
}

export async function createOwnerSubAccount(
  payload: ICreateSubAccountPayload
): Promise<ISubAccount | null> {
  const response = await api.post(SUB_ACCOUNTS_ENDPOINT, payload);
  return normalizeSubAccount(response.data?.data ?? response.data);
}

export async function updateOwnerSubAccount(
  id: number,
  payload: IUpdateSubAccountPayload
): Promise<ISubAccount | null> {
  const response = await api.put(`${SUB_ACCOUNTS_ENDPOINT}/${id}`, payload);
  return normalizeSubAccount(response.data?.data ?? response.data);
}

export async function deleteOwnerSubAccount(id: number): Promise<void> {
  await api.delete(`${SUB_ACCOUNTS_ENDPOINT}/${id}`);
}
